module.exports = __webpack_public_path__ + "img/ocoin_officetokens.d517393.png";